<template>
  <el-form ref="baseForm" :rules="rules" :model="fromData">
  <search-box @subSearch="subSearch" :fromData="fromData">
    <el-form-item class="item" label="客户：" prop="customerCode">
      <el-input  v-model="fromData.searchCriteria.codeOrDesc" clearable :placeholder="$store.state.remark.customer"></el-input>
    </el-form-item>
  </search-box>
  </el-form>
</template>

<script>
import searchBox from 'components/common/search.vue';
export default{
  components:{
    searchBox
  },
  props:{
    fromData:Object
  },
  data(){
    return{
      rules: {
        customerCode:[{message: "",trigger: "blur"}],
        customerDesc:[{message: '',trigger: 'change'}]
      }
    }
  },
  methods:{
    //搜索
    subSearch(){
      this.$emit('subSearch');
    }
  }
}
</script>

<style>
</style>
